import { register } from 'larasnap';
import HistoryViewer from './HistoryViewer';

register(HistoryViewer);
